import "rxjs/add/operator/mergeMap";
import { Types, Creators } from "../reducer";

import * as firebase from "firebase";

export default action$ =>
  action$.ofType(Types.CHANGE_LANE).mergeMap(action =>
    firebase
      .database()
      .ref(
        `ranges/${action.location}/${action.range}/lane-${action.laneNumber}`
      )
      .update(action.updateLaneObject)
      .then(() => Creators.completeEditLane())
      // FIXME: handle error case, a common handling?
      .catch(() => Creators.completeEditLane())
  );



// WEBPACK FOOTER //
// ./src/staff/epics/changeLane.js